import React from 'react';
import Rubric from 'features/EventOverviewContainer/components/JudgingRubric';

const JudgingRubric = (props) => {
  return (
    <Rubric {...props} />
  );
};

export default JudgingRubric;